import { Controller } from "@hotwired/stimulus";

// Replaces the ajax:success/ajax:error handling that used to live in
// SearchfieldWidget#load (searchfield_widget.ts), gated off for rebuilt
// pages along with the rest of Searchfield.load() (see packs/desktop/step1.js).
// That handler relied on jquery_ujs's custom `ajax:success`/`ajax:error`
// events fired for `remote: true` forms; this does the equivalent with a
// plain fetch, matching SearchController#new_search's actual contract:
// `render json: { url: step_path(1, search) }` on success, or
// `render json: { errors: search.to_a } }` (array of [field, [messages]])
// on validation failure.
export default class extends Controller {
  static targets = ["errorBanner", "overlay"];
  static values = { genericError: String };

  async submit(event) {
    event.preventDefault();
    const form = this.element;
    this.clearErrors();
    this.showLoading();

    let response;
    try {
      response = await fetch(form.action, {
        method: form.method || "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
    } catch (e) {
      this.hideLoading();
      this.showErrors([this.genericErrorValue]);
      return;
    }

    let data;
    try {
      data = await response.json();
    } catch (e) {
      this.hideLoading();
      this.showErrors([this.genericErrorValue]);
      return;
    }

    if (data.url) {
      // Leave the overlay showing / button disabled through the navigation
      // itself -- avoids a flash of the plain form right before the page
      // unloads, and prevents a double-submit while that navigation settles.
      window.location.href = data.url;
    } else if (data.errors) {
      this.hideLoading();
      this.showErrors(data.errors.map((errorObj) => errorObj[1]).flat());
    } else {
      this.hideLoading();
      this.showErrors([this.genericErrorValue]);
    }
  }

  showLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden");
      this.overlayTarget.classList.add("flex");
    }
    const button = this.element.querySelector('[type="submit"]');
    if (button) button.disabled = true;
  }

  hideLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden");
      this.overlayTarget.classList.remove("flex");
    }
    const button = this.element.querySelector('[type="submit"]');
    if (button) button.disabled = false;
  }

  showErrors(messages) {
    if (!this.hasErrorBannerTarget || messages.length === 0) return;
    this.errorBannerTarget.innerHTML = messages
      .map((m) => `<div>${m}</div>`)
      .join("");
    this.errorBannerTarget.classList.remove("hidden");
  }

  clearErrors() {
    if (!this.hasErrorBannerTarget) return;
    this.errorBannerTarget.classList.add("hidden");
    this.errorBannerTarget.innerHTML = "";
  }
}
